import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useRef } from "react";

interface IProp {
  path: {
    lat: number;
    lng: number;
  }[];
  strokeColor: string;
  strokeOpacity: number;
  strokeWeight: number;
}

export const Polyline = ({
  path,
  strokeColor,
  strokeOpacity,
  strokeWeight,
}: IProp) => {
  const map = useMap();
  const polylineRef = useRef<google.maps.Polyline | null>(null);

  useEffect(() => {
    if (!map) return;

    // Remove previous polyline if exists
    if (polylineRef.current) {
      polylineRef.current.setMap(null);
    }

    // Create new polyline
    polylineRef.current = new google.maps.Polyline({
      path,
      strokeColor,
      strokeOpacity,
      strokeWeight,
      map,
    });

    return () => {
      if (polylineRef.current) {
        polylineRef.current.setMap(null);
      }
    };
  }, [map, path, strokeColor, strokeOpacity, strokeWeight]);

  return null;
};
